/**
 * @Author: Michael Neumair <mBook>
 * @Date:   2016-10-04T14:51:06+02:00
 * @Email:  7q7w7e7r@gmail.com
 * @Last modified by:   mBook
 * @Last modified time: 2016-10-07T13:32:51+02:00
 */


import React, {Component, Children} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {getModel, actions} from 'react-redux-form/src';
import isPromise from 'is-promise';
import warning from 'warning';
import {animateScroll} from 'react-scroll';
import {
  loadHtmlContent,
  i18nInterface,
} from 'utilities/i18n_common';

import MNavigationBottomCheckout, {
  BUTTON_STYLE_SPINNER,
  BUTTON_STYLE_OUTLINE,
  BUTTON_STYLE_FILLED,
} from './../components/MNavigationBottomCheckout';
import MHeadlineCheckout from 'checkout/components/MHeadlineCheckout';
import MStepperCheckout from 'checkout/components/MStepperCheckout';
import MDisplayFormError from 'common/inputs/containers/MDisplayFormError';
import MTopbarCheckout from 'checkout/components/MTopbarCheckout';
import OFormareaCheckout from 'checkout/components/OFormareaCheckout';
import OBodyCheckout from 'checkout/components/OBodyCheckout';
import OSidebarCheckout from 'checkout/components/OSidebarCheckout';
import OHelpCheckout from 'checkout/components/OHelpCheckout';
import AStepCheckout from 'checkout/components/AStepCheckout';
import OSaveDialog from 'checkout/components/OSaveDialog';
import {saveProgress, xhrSaveCid} from '../../utilities/cidRequests';
import store from '../../checkout/store';
import {
  closeHelp as closeHelpActionCreator,
  setHelpHtml as setHelpHtmlActionCreator,
  openHelp as openHelpActionCreator,
} from './../actions/checkoutHelpActions';

// utils
import {
  getInfoLinks,
} from 'checkout/utils/infoLinks';

// cors utils
import {
  getSidebarUrl,
} from 'utilities/corsTargets';
import console from '../../utilities/console';
import isEmpty from 'lodash/isEmpty';

// tooltip
import reactHintFactory from 'react-hint';
import breakpointProp from '../../utilities/breakpointProp';
import ATooltip from '../components/ATooltip';

const ReactHint = reactHintFactory(React);

const cantLoadExternalHtml = '<p>Externes Dokument konnten nicht geladen ' +
  'werden. Bitte wenden Sie sich an den Support.</p>';


/**
 * show errors on a field
 *
 * @see https://davidkpiano.github.io/react-redux-form/docs/api/Errors.html#show
 * @param  {object} field field store
 * @return {Boolena}       if errors should be shown
 */
function showErrors(field) {
  return field.touched && !field.focus;
}

/**
 * @see https://facebook.github.io/react/tips/dangerously-set-inner-html.html
 *
 * @param {string} html
 * @return {object}
 */
function createMarkup(html) {
  return {__html: html};
}

/**
 * called from react-redux connect() on a redux store update
 *
 * @param {object} state
 * @param {object} ownProps
 * @return {object}
 */
function mapStateToProps(state, ownProps) {
  const formModel = getModel(state, ownProps.formModel);
  return {
    deposit: parseFloat(formModel.objective.deposit),
    helpShow: state.checkoutHelp.open,
    helpHtml: state.checkoutHelp.html,
    helpId: state.checkoutHelp.helpId,
    email: formModel.firstTenant.email,
    forceToShowErrors: formModel.formHandling.forceToShowErrors,
    interactiveLock: formModel.formHandling.interactiveLock,
    paymentConditions: formModel.objective.paymentConditions &&
      formModel.objective.paymentConditions.toString() || '1',
  };
}

const SAVE_DIALOG_ID = 'save.dialog';

/**
 * called from react-redux connect() on a redux store update
 * enables component to send actions via dispatch() to react-redux
 *
 * @param {function} dispatch
 * @param {object} ownProps
 * @return {object}
 */
function mapDispatchToProps(dispatch, ownProps) {
  const {
    formModel,
    activeMaskMerge,
  } = ownProps;

  return {
    applyFormFilterKeys: () => {
      dispatch({
        type: 'HAS_ACTIVE_MASK_FOR',
        activeMask: [
          `${formModel}.objective.target`,
          `${formModel}.objective.deposit`,
        ],
        activeMaskMerge,
      });
    },
    setPrefillTarget: (val) => dispatch(
      actions.change(`${formModel}.objective.target`, val),
    ),
    helpDispatch: {
      close: () => dispatch(closeHelpActionCreator()),
      open: (id) => dispatch(openHelpActionCreator(id)),
      setHtml: (htmlString) => dispatch(setHelpHtmlActionCreator(htmlString)),
    },
    resetFormValidity: () => dispatch(actions.resetValidity(formModel)),
  };
}


/**
 * TCheckoutPage - …
 **/
class TCheckoutPage extends Component {
  /**
   * TODO jsdoc
   *
   * @param {object} props
   * @return {undefined}
   */
  constructor(props) {
    super(props);

    this.state = {
      sidebarHtml: '',
      parentFrame: {},
      helpOffsetTop: 0,
      i18nWithReservation: false,
      saveDialogErrors: '',
    };
  }

  /**
   * TODO jsdoc
   *
   * @return {undefined}
   */
  componentDidMount() {
    this.getSidebarContent();
    if (window) {
      this.updateOffsetListener = () => {
        const topOffset = this.scrollRef.getBoundingClientRect().top;
        if (typeof window.OA_HELP_STATIC_OFFSET_TOP != 'undefined') {
          this.setState({
            helpOffsetTop: (topOffset > window.OA_HELP_STATIC_OFFSET_TOP
              ? topOffset : window.OA_HELP_STATIC_OFFSET_TOP),
          });
        } else {
          this.setState({
            helpOffsetTop: (topOffset > 0 ? topOffset : 0),
          });
        }
      };
      window.addEventListener('scroll', this.updateOffsetListener);
      this.updateOffsetListener();
    }

    this.checkReservationFlags();
  }

  /**
   * TODO jsdoc
   *
   * @param {object} nextProps
   * @return {undefined}
   */
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.forceToShowErrors &&
      this.props.forceToShowErrors !== nextProps.forceToShowErrors
    ) {
      this.showFormErrors();
    }

    if (
      nextProps.loadSidebarContent &&
      this.props.loadSidebarContent !== nextProps.loadSidebarContent
    ) {
      this.getSidebarContent(nextProps.loadSidebarContent);
    }

    this.checkReservationFlags(nextProps);
  }

  /**
   * TODO jsdoc
   *
   * @return {undefined}
   */
  componentWillUnmount() {
    this.props.resetFormValidity();
    if (window) {
      window.removeEventListener('scroll', this.updateOffsetListener);
    }
  }

  /**
   *
   * @param {object} event
   * @param {string} email
   */
  async onPressButtonSaveDialog(event, email) {
    this.setState({
      saveDialogErrors: '',
    });
    const {steps} = this.props;
    const activeStep = steps.find((step) => step.active);
    const cid = store.cid;

    const self = this;

    await xhrSaveCid(cid, activeStep, false).then(
        (xhr) => {
        }, (xhr) => {
          // error occured
          console.log(`XhrSaveCID Error for ${store.cid}`);
          if (xhr.status == 0) {
            console.log('CORS - not allowed');
          } else {
            console.log(xhr);
          }
        }
    );

    await saveProgress(cid, activeStep.key, email).then(
        (xhr) => {
          const data = JSON.parse(xhr.responseText || '' +
                '{"errors": {"xhr": "unable to parse JSON (xhr)"}}');
          if (isEmpty(data.errors)) {
            this.props.helpDispatch.close();
          } else {
            self.setState({
              saveDialogErrors: data.errors,
            });
          }
        }, (xhr) => {
          // error occured
          self.setState({
            saveDialogErrors: 'error.unknown',
          });
          console.log(`XhrSaveCID Error for ${store.cid}`);
          if (xhr.status == 0) {
            console.log('CORS - not allowed');
          } else {
            console.log(xhr);
          }
        }
    );
  }

  /**
   * TODO jsdoc
   *
   * @return {object}
   */
  render() {
    const {
      formModel,
      formErrorMessage,
      forms,
      deposit,
      styleButtonForward,
      helpId,
      email,
      helpDispatch,
      helpShow,
      helpHtml,
      closeHelp, // eslint-disable-line no-unused-vars
      forceToShowErrors, // eslint-disable-line no-unused-vars
      onPressLinkPrevious,
      onPressButtonForward, // eslint-disable-line no-unused-vars
      interactiveLock,
      subButtonText,
      childrenHandlesCheckout,
      paymentConditions,
      usePlainChildren,
      breakpoint,
    } = this.props;


    const isMobile = breakpoint !== 'checkout' && breakpoint !== 'wide';
    const showTooltip = !isMobile;

    const htmlContent = this.getHelpContent(showTooltip);

    return (
      <div className="t-checkout t-checkout-page"
        onKeyUp={(event) => this.setState({showFormErrors: false})}
        ref={(component) => {
          this.scrollRef = component;
        }}
      >
        {deposit && deposit > 0 ?
          (<MTopbarCheckout
            deposit={deposit}
            paymentConditions={paymentConditions}
          />) :
          null
        }
        <OBodyCheckout>
          <OFormareaCheckout
            footerLinks={typeof window != 'undefined' &&
            window.OA_OWN_FOOTER_LINKS || {
              a: {
                label: 'Impressum',
                href: 'https://kautionsfrei.de/impressum',
                target: '_blank',
              },
              b: {
                label: 'Datenschutz',
                href: 'https://kautionsfrei.de/datenschutz',
                target: '_blank',
              },
              c: {
                label: 'Versicherungsbedingungen',
                href: getInfoLinks()['Versicherungsbedingungen'],
                target: '_blank',
              },
              d: {
                label: 'Widerrufsbelehrung',
                href: getInfoLinks()['Widerrufsbelehrung'],
                target: '_blank',
              },
            }}>
            <MStepperCheckout>
              {this.renderSteps()}
            </MStepperCheckout>
            {
              !usePlainChildren && Children.map(forms, (form) => (
                React.cloneElement(form, {
                  formModel: formModel,
                  showErrors: (this.state.showFormErrors) ? true : showErrors,
                  onPressHelp: (helpId, event, stopEvent) =>
                    this.openHelp(helpId, event, stopEvent),
                  // this is a hack to have the same functionality
                  // on the checkout button inside OSumBoxCheckout
                  ...(childrenHandlesCheckout ?
                      {
                        onPressCheckout: (e) =>
                          this.handleOnPressButtonForward(e),
                      } :
                      {}
                  ),
                })
              )) || forms
            }
            {
              this.state.showFormErrors &&
              <MDisplayFormError
                formModel={formModel}
                showErrors={this.state.showFormErrors}
                message={formErrorMessage}
              />
            }
            {(onPressLinkPrevious || onPressButtonForward) &&
            <MNavigationBottomCheckout
              labelLinkPrevious={this.backLinkText()}
              labelButtonForward={this.forwardLinkText()}
              labelLinkSave={i18nInterface('saveProgress.linkLabel')}
              styleButtonForward={interactiveLock ?
                BUTTON_STYLE_SPINNER : styleButtonForward}
              onPressLinkPrevious={onPressLinkPrevious}
              onPressButtonForward={(e) => this.handleOnPressButtonForward(e)}
              onPressLinkSave={(e) => helpDispatch.open(SAVE_DIALOG_ID)}
              showLinkSave={!this.isSaveDialogDisabled()}
              subButtonText={subButtonText}
            />
            }
            <div id='modalAnchor'></div>
          </OFormareaCheckout>
          <OSidebarCheckout>
            <div onClick={this.handleSidebarClick}
              dangerouslySetInnerHTML={
                createMarkup(this.state.sidebarHtml)
              }/>
          </OSidebarCheckout>
        </OBodyCheckout>
        {showTooltip ? <ReactHint
          persist={true}
          events={{click: true, hover: false}}
          position={'right'}
          ref={(ref) => this.instance = ref}
          onRenderContent={(target, content) => htmlContent}
        /> : <OHelpCheckout
          onPressClose={(e) => this.handleOnPressCloseHelp(e)}
          show={helpShow}
          offsetTop={this.state.helpOffsetTop}
        >
          {htmlContent}
        </OHelpCheckout>
        }
      </div>
    );
  }

  /**
   * Get help content as JSX. If it should be shown in a tooltip, it is wrapped in ATooltip
   * Componen
   *
   * @param {boolean} showTooltip
   * @return {JSX}
   */
  getHelpContent(showTooltip) {
    const {
      helpId,
      formModel,
      email,
      helpHtml,
    } = this.props;

    let content = null;
    if (helpId === SAVE_DIALOG_ID) {
      content = <OSaveDialog
        formModel={formModel}
        email={email}
        onPressButtonSave={(e, email) => this.onPressButtonSaveDialog(e, email)}
        errors={this.state.saveDialogErrors}
      />;
    } else {
      content = <div dangerouslySetInnerHTML={createMarkup(helpHtml)}/>;
    }

    return showTooltip ? <ATooltip
      onPress={(e) => {
        /**
             * Timeout is needed due to 2 click events fired when the closing X is clicked. The
             * one is the bound click Event to the X the other the general click that is bound to
             * document (from react-hint library). The delay is needed that the Tooltip is finally
             * hidden.
             */

        setTimeout(() => this.instance.toggleHint({target: null}, 200));
      }}
    >{content}</ATooltip> : content;
  }


  isSaveDialogDisabled() {
    let isDisabled = true;
    if (window) {
      isDisabled = window.OA_SAVE_DIALOG_DISABLED ? true : false;
    }

    return isDisabled;
  }

  /**
   * enables reservation mode from props
   *
   * @param {object} props
   * @return {undefined}
   */
  checkReservationFlags(props = this.props) {
    let i18nWithReservation = false;

    Children.forEach(
        props.forms,
        (form) =>
          i18nWithReservation = i18nWithReservation ||
          (form.props && form.props.isSingleTenant),
    );

    this.setState({i18nWithReservation: i18nWithReservation});
  }

  /**
   * creates text for link button "backward"
   *
   * @return {string}
   */
  backLinkText() {
    if (this.allStepsHidden()) {
      return '';
    }
    const {steps} = this.props;
    let i18nId = 'navigate.backward_button_label';
    const stepPageIndex = steps.findIndex((step) => step.active);

    if (stepPageIndex > 0) {
      i18nId = i18nId + '.' + steps[stepPageIndex - 1].key;
      return i18nInterface(i18nId);
    } else {
      return '';
    }
  }

  /**
   * creates text for link button "forward"
   *
   * @return {string}
   */
  forwardLinkText() {
    const {steps} = this.props;
    let i18nId = 'navigate.forward_button_label';
    const stepPageIndex = steps.findIndex((step) => step.active);

    if ((stepPageIndex + 1) < steps.length && !this.allStepsHidden()) {
      i18nId = i18nId + '.' + steps[stepPageIndex + 1].key;
    } else {
      if (window && window.OA_SINGLE_STEP
        && !this.state.i18nWithReservation) {
        return 'Weiter';
      } else {
        i18nId = i18nId + '.finish_wizard' +
          (this.state.i18nWithReservation ? '_reservation' : '');
      }
    }
    return i18nInterface(i18nId);
  }

  /**
   * scroll integration on errors
   * queries the DOM tree for .error and scrolls to first occurence
   * compatible with iframe embed as from
   * https://github.com/davidjbradshaw/iframe-resizer
   *
   * @return {undefined}
   */
  errorScroll() {
    // invalid form is set now do scroll to error on iframe or direct
    if (typeof document != 'undefined' &&
      document.getElementsByClassName('error').length > 0) {
      /**
       * find a minimal offset
       *
       * @return {number}
       */
      function getMinimalOffset() {
        const errorNodes = document.getElementsByClassName('error');
        let minimalOffset = null;
        for (let i = 0; i < errorNodes.length; i++) {
          let offsetNode = errorNodes[i];
          let offsetTop = offsetNode.offsetTop;
          while (offsetNode = offsetNode.offsetParent) {
            if (!isNaN(offsetNode.offsetTop)) {
              offsetTop += offsetNode.offsetTop;
            }
          }

          const errorScrollFuzz = typeof window != 'undefined' &&
            window.OA_SCROLL_FUZZ || 24;
          offsetTop = (offsetTop > errorScrollFuzz ?
            offsetTop - errorScrollFuzz : 0);

          if (minimalOffset == null) {
            minimalOffset = offsetTop;
          } else {
            if (minimalOffset > offsetTop) {
              minimalOffset = offsetTop;
            }
          }
        }
        return minimalOffset;
      }

      /*
       * do scroll
       */
      animateScroll.scrollTo(getMinimalOffset());
    }
  }

  /**
   * render Steps as <AStepCheckout> Elements
   *
   * @return {array}
   */
  renderSteps() {
    const {steps} = this.props;
    const stepPageIndex = steps.findIndex((step) => step.active);

    if (
      !steps[stepPageIndex] ||
      steps[stepPageIndex].hide === true
    ) {
      return null;
    }

    return steps.map((step) => {
      return (!step.hide && <AStepCheckout {...step}/>);
    });
  }

  /**
   * async loading of html over loadHtmlContent() for use in sidebar
   *
   * @param {string} sidebarId
   * @return {undefined}
   */
  getSidebarContent(sidebarId = this.props.loadSidebarContent) {
    const url = getSidebarUrl(sidebarId);
    const result = loadHtmlContent(
        url,
        cantLoadExternalHtml,
    ).then((responseText) => {
      // filter responseText for sidebar content comments
      const regexp =
        /<!-- SIDEBAR_CONTENT -->([\s\S]*?)<!-- SIDEBAR_CONTENT -->/g;
      const contentSplit = regexp.exec(responseText);
      if (contentSplit !== null && contentSplit.length > 1) {
        return contentSplit[1];
      } else {
        if (cantLoadExternalHtml == responseText) {
          warning(false, 'Error loading html sidebar from <' + url + '>');
        }
        return responseText;
      }
    }).then((html) => {
      if (this.setState) {
        this.setState({sidebarHtml: html});
      }
      if (typeof window != 'undefined' &&
        typeof window.OA_SIDEBAR_AFTER_LOAD == 'function') {
        window.OA_SIDEBAR_AFTER_LOAD();
      }
    }).catch((reason) => {
      warning(false, reason);
    });
  }

  /**
   * openHelp handler
   *
   * @param {object} event
   * @return {undefined}
   */
  handleOnPressButtonForward(event) {
    const {onPressButtonForward} = this.props;

    const async = new Promise((resolve) => {
      if (!this.state.showFormErrors) {
        this.showFormErrors();
      }
      resolve(event);
      return this;
    });

    return async.then((event) => {
      if (onPressButtonForward) {
        onPressButtonForward(event);
        this.errorScroll();
      }
      return this;
    });
  }

  /**
   * closeHelp handler on keyboard
   *
   * @param {object} event
   * @return {undefined}
   */
  escCloseHelp(event) {
    if (event.keyCode === 27) {
      this.handleOnPressCloseHelp(event);
    }
  }

  /**
   * openHelp handler
   *
   * @param {string} nextHelpId
   * @param {object} event
   * @param {bool} stopEvent
   * @return {undefined}
   */
  openHelp(nextHelpId, event, stopEvent) {
    const {
      helpDispatch,
      helpShow,
      helpId,
    } = this.props;

    if (stopEvent) {
      event.preventDefault();
      event.stopPropagation();
    }

    // offset help screen if we are on iframe
    if (window.parent != window && event.target) {
      // only offset if we have scrolled completely into iframe
      if ((this.state.parentFrame.offsetTop || 0) <
        (this.state.parentFrame.scrollTop || 0)) {
        this.setState({
          helpOffsetTop:
            this.state.parentFrame.scrollTop - this.state.parentFrame.offsetTop,
        });
      } else {
        this.setState({helpOffsetTop: 0});
      }
    }

    if (helpShow && nextHelpId === helpId) {
      helpDispatch.close();
    } else {
      helpDispatch.open(nextHelpId);
      const result = i18nInterface(nextHelpId);

      // if we got a promise we expect the html will be laoded async
      if (isPromise(result)) {
        // resolve async promise
        result.then((html) => {
          if (typeof html !== 'string') {
            helpDispatch.setHtml(cantLoadExternalHtml);
            warning(false, `Expect help content to be a string but got ${typeof html}. Promised resolved to non-string value, which can not be displayed.`); // eslint-disable-line max-len
          }
          helpDispatch.setHtml(html);
        }).catch((reason) => {
          helpDispatch.setHtml(cantLoadExternalHtml);
          warning(false, reason);
        });
      } else {
        if (typeof result !== 'string') {
          // we do not have a proper value, show an error ...
          helpDispatch.setHtml(cantLoadExternalHtml);
          warning(false, `Expect help content to be a string but got ${typeof html}. Return is non-string value, which can not be displayed.`); // eslint-disable-line max-len
        } else {
          helpDispatch.setHtml(result);
        }
      }
    }

    if (document) {
      document.addEventListener('keydown', (e) => this.escCloseHelp(e), false);
    }
  }

  /**
   * closeHelp handler
   *
   * @param {object} event
   * @return {undefined}
   */
  handleOnPressCloseHelp(event) {
    const {
      closeHelp,
      onPressCloseHelp,
      helpDispatch,
    } = this.props;

    helpDispatch.close();

    if (onPressCloseHelp) {
      onPressCloseHelp(event);
    }

    if (document) {
      document.removeEventListener('keydown', (e) =>
        this.escCloseHelp(e), false);
    }
  }

  /**
   * currently only used to find out if we are on a reservation
   *
   * @return {boolean}
   */
  allStepsHidden() {
    const {steps} = this.props;
    // check if all steps are hidden
    let allHidden = true;
    for (const index in steps) {
      allHidden = allHidden && steps[index].hide;
    }
    return allHidden;
  }

  /**
   * TODO jsdoc
   *
   * @return {undefined}
   */
  showFormErrors() {
    if (!this.state.showFormErrors) {
      this.setState({showFormErrors: true}, () => {
        this.errorScroll();
      });
    } else {
      this.errorScroll();
    }
  }

  /**
   * TODO jsdoc
   *
   * @param {object} event
   * @return {undefined}
   */
  handleSidebarClick(event) {
    if (event.target) {
      let parentNode = event.target;
      for (let i = 0; i < 4; i++) {
        parentNode = parentNode.parentNode;
        if (!parentNode) break;
        if (parentNode.id == 'chat-connect' && typeof SnapABug == 'object') {
          SnapABug.startLink();
          break;
        }
      }
    }
  }
}

TCheckoutPage.propTypes = {
  /**
   * model of the form
   */
  formModel: PropTypes.string.isRequired,
  /**
   * one or more forms to summarize within the page
   */
  forms: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired, // form
  /**
   * progress bar steps
   * @type {Array}
   */
  steps: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    onPress: PropTypes.func,
  })),
  /**
   * error message displayed at the bottom when the form has errors
   */
  formErrorMessage: PropTypes.string.isRequired,
  /**
   * style of the forward button, filled or outline
   * default is outline
   */
  styleButtonForward: PropTypes.oneOf(
      [
        BUTTON_STYLE_OUTLINE,
        BUTTON_STYLE_FILLED,
      ],
  ),
  /**
   * function which returns the html content for
   * the sidebar view synchronously or asynchronously
   *
   * the function should return a html-string or a
   * promise. Use the promise for async actions. the
   * promise should resolve to a async-html-string.
   */
  loadSidebarContent: PropTypes.any.isRequired,
  /**
   * fired when the help will be closed
   */
  onPressCloseHelp: PropTypes.func,
  /**
   * callbacks fired when the prev or next link/button
   * was pressed. you should decide what to do next.
   * for example laod another page with window.location = 'url'
   * or do something eles ...
   */
  onPressLinkPrevious: PropTypes.func,
  onPressButtonForward: PropTypes.func,


  /**
   * stuff loaded by redux, do not pass it directly, wont do anything :)
   */
  deposit: PropTypes.number, // passed by redux
  forceToShowErrors: PropTypes.bool.isRequired, // passed by redux
  interactiveLock: PropTypes.bool.isRequired, // passed by redux
  helpDispatch: PropTypes.shape({
    close: PropTypes.func,
    open: PropTypes.func,
    setHtml: PropTypes.func,
  }), // passed by redux
  /**
   * ATextInputDescription below navigation elements in bottom
   */
  subButtonText: PropTypes.string,
  /**
   * pass handler for checkout button click down to any children
   */
  childrenHandlesCheckout: PropTypes.bool,
  /**
   * renders children without passed props from main component
   */
  usePlainChildren: PropTypes.bool.isRequired,
};
TCheckoutPage.defaultProps = {
  formErrorMessage: i18nInterface('error.global_appendix'),
  subButtonText: '',
  childrenHandlesCheckout: false,
  usePlainChildren: false,
};

export default breakpointProp(connect(mapStateToProps, mapDispatchToProps)(TCheckoutPage));
